const t = "_AvatarStatusContainer_1h3v1_1", a = "_sm_1h3v1_4", s = "_md_1h3v1_7", _ = "_lg_1h3v1_10", n = {
  AvatarStatusContainer: t,
  sm: a,
  md: s,
  lg: _
};
export {
  t as AvatarStatusContainer,
  n as default,
  _ as lg,
  s as md,
  a as sm
};
//# sourceMappingURL=AvatarStatus.module.scss.js.map
